import React, { useState, useEffect } from "react";
import "hammerjs";
import { Spin, Divider, Progress, Flex, Image } from "antd";
import "./Dashboard.css";
import { GoProjectRoadmap } from "react-icons/go";
import { useNavigate } from "react-router";
import Layout from "../../components/global/layout";
import { API_URL } from "../../environment";
import ApiClient from "../../methods/api/apiClient";


const DashBoard = () => {
  const navigate = useNavigate();
  const [employeeData, setEmployeeData] = useState({});
  const [employeeProjectData, setEmployeeProjectData] = useState({});
  const [announcementsData, setannouncementsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [upcomingevent, setUpcomingevent] = useState([]);
  const token = localStorage.getItem("token");
  const tl = localStorage.getItem("tl")
  const role = localStorage.getItem("role")
  const [employeeAnalytics, setEmployeeAnalytics] = useState();
  const [projecttotal, setprojecttotal] = useState(0);

 


  

  
  useEffect(() => {
    userProjects();
    userDetails();
    announcements();
    getUpcomingEvents();
    getEmployeeAnalytics()
 

    


      }, []);



  const getEmployeeAnalytics = () => {
    setLoading(true);
    ApiClient.get(`employeeAnalytics`)
      .then((res) => {
        setEmployeeAnalytics(res);
        setprojecttotal(res.projects?.totalProjects)
        
      })
      .catch((err) => setLoading(false));
  };

  const event = () => {
    navigate("/announcementlist");
  };
  const getUpcomingEvents = () => {
    setLoading(true);
    ApiClient.get(`event/list`)
      .then((res) => {
        setUpcomingevent(res);
        setLoading(false);
      })
      .catch((err) => setLoading(false));
  };

  const userDetails = () => {
    const userid = localStorage.getItem("USERID");
    fetch(`${API_URL}userDetail?id=${userid}`, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((res) => {
        setEmployeeData(res);
      });
  };

  const userProjects = () => {
    fetch(`${API_URL}getprojectstatuscount`, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((res) => {
        setEmployeeProjectData(res.data || {});
      });
  };
  const today = new Date().toISOString().split("T")[0];
  const employeeDob = employeeData.data?.dob;

  const announcements = () => {
    setLoading(true);
    fetch(`${API_URL}announcementListing?page=1&count=1000000`, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((res) => {
        const todayAnnouncements = res.data.filter(
          (announcement) => announcement.date === today
        );
        setannouncementsData(todayAnnouncements);
        setLoading(false);
       
      });
  };
  const filteredProjects = (type) => {
    // history(`/allProject?projectstatus=${type}`);
  };
  const totalProjects =
    (employeeProjectData.InProgress?.length || 0) +
    (employeeProjectData.Failed?.length || 0) +
    (employeeProjectData.Success?.length || 0);
  const completedProjects = employeeProjectData.Success?.length || 0;
  const inProgressProjects = employeeProjectData.InProgress?.length || 0;
  const failedProjects = employeeProjectData.Failed?.length || 0;

  const chartData = [
    ["Status", "Count"],
    ["Total", totalProjects],
    ["Completed", completedProjects],
    ["In Progress", inProgressProjects],
    ["Failed", failedProjects],
  ];

  const chartsOptions = {
    title: "Project Status Overview",
    hAxis: { title: "", minValue: 0 },
    vAxis: { title: "" },
    legend: "none",
    colors: ["#ff8f27"],
  };

 
  

  const Link=(e)=>{
    navigate(e)
  }

  return (
    <Layout>
      <div className="main_dashboards">
        <div className="row py-3">
          <div className="col-sm-12 text-capitalize" >
            <h3 className="main-title-new">
              Welcome{" "}
              <span className="primary font800">
                {employeeData.data?.fullName} {tl === 'true' ? <span>({employeeData?.data?.tlTechnology} TL)</span> : ''} {tl === 'false' ? <span>({role})</span> : ''}
              </span>
              {/* You are login with */}
{/*         
              <div>
      <h2>🔍 Device Info</h2>
      <p><strong>Device Type:</strong> {deviceDetails.deviceType}</p>
      <p><strong>Operating System:</strong> {deviceDetails.os}</p>
      <p><strong>Ip Address:</strong> {ipAddress}</p>

      
    </div> */}
            </h3>
            {/* <div>
      <ul>
        <li><strong>City:</strong> {locationData?.city}</li>
        <li><strong>Locality:</strong> {locationData?.locality}</li>
        <li><strong>Principal Subdivision:</strong> {locationData?.principalSubdivision}</li>
        <li><strong>Country:</strong> {locationData?.countryName}</li>
        <li><strong>Continent:</strong> {locationData?.continent}</li>
      </ul>
    </div>
     */}
          </div>

          <div className="mt-2">
            <div className="row">
              {/* <div className="col-12 col-md-6">
                <div className="card">
                  <div className="card-body info-wrapper">
                    <div className="d-flex flex-column align-items-start">
                      <div className="dashtitles mb-2">
                        <p>Total Projects: {totalProjects}</p>
                      </div>
                      <div className="dashtitles mb-2">
                        <p>Completed: {completedProjects}</p>
                      </div>
                      <div className="dashtitles mb-2">
                        <p>Working: {inProgressProjects}</p>
                      </div>
                      <div className="dashtitles mb-2">
                        <p>Failure: {failedProjects}</p>
                      </div>
                      <div className="icons_dash mt-3"
                        onClick={() => {
                          navigate("/projectassigntable");
                        }}
                        style={{ cursor: "pointer" }}>
                        <GoProjectRoadmap
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}

              <div className="col-12">
                {/* <div className="card">
                  <div className="card-body info-wrapper">
                      <div className="dashtitles mb-2">
                        <p>Total Leaves: {employeeData?.data?.leavesDetails?.paidLeavesTillNow + employeeData?.data?.leavesDetails?.unpaidLeaves || 0}</p>
                      </div>
                      <div className="dashtitles mb-2">
                        <p>Paid Leaves Taken: {employeeData?.data?.leavesDetails?.paidLeavesTillNow - employeeData?.data?.leavesDetails?.paidLeavesLeftTillNow || 0}</p>
                      </div>
                      <div className="dashtitles mb-2">
                        <p>Unpaid Leaves Taken: {employeeData?.data?.leavesDetails?.unpaidLeaves || 0}</p>
                      </div>
                      <div className="dashtitles mb-2">
                        <p>Remaining Leave: {employeeData?.data?.leavesDetails?.paidLeavesLeftTillNow || 0}</p>
                      </div>

                      <div className="icons_dash mt-3"
                        onClick={() => {
                          navigate("/projectassigntable");
                        }}
                        style={{ cursor: "pointer" }}>
                        <GoProjectRoadmap
                        />
                      </div>
                  </div>
                </div> */}
                 {/* onClick={()=>Link('/leavelist')} */}
                <div className="row m-0 cursor-pointer" >
                  <div className="col-md-6 col-lg-3 p-3">
                    <div className="info-wrapper-2">
                      <div className="card mb-0">
                        <div className="card-body p-0">
                          <div className="d-flex align-items-center flex-column justify-content-between">
                            <div className="icons_dash mb-3 cursor-pointer" onClick={()=>Link('/leavelist')} >
                              <GoProjectRoadmap />
                            </div>
                            <div className="dashtitles">
                              <h4 className="text-center">{employeeAnalytics?.totalLeave }</h4>
                              <p className="text-center">Total Leaves</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6 col-lg-3 p-3">
                    <div className="info-wrapper-2">
                      <div className="card mb-0">
                        <div className="card-body p-0">
                          <div className="d-flex align-items-center flex-column justify-content-between">
                            <div className="icons_dash mb-3">
                              <GoProjectRoadmap />
                            </div>
                            <div className="dashtitles" >
                              <h4 className="text-center">{employeeAnalytics?.takenPaidLeaves}</h4>
                              <p className="text-center">Paid Leaves Taken</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-3 p-3">
                    <div className="info-wrapper-2">
                      <div className="card mb-0">
                        <div className="card-body p-0">
                          <div className="d-flex align-items-center flex-column justify-content-between">
                            <div className="icons_dash mb-3">
                              <GoProjectRoadmap />
                            </div>
                            <div className="dashtitles">
                              <h4 className="text-center">{employeeAnalytics?.takenUnpaidLeaves}</h4>
                              <p className="text-center">Unpaid Leaves taken</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-3 p-3">
                    <div className="info-wrapper-2">
                      <div className="card mb-0">
                        <div className="card-body p-0">
                          <div className="d-flex align-items-center flex-column justify-content-between">
                            <div className="icons_dash mb-3">
                              <GoProjectRoadmap />
                            </div>
                            <div className="dashtitles">
                              <h4 className="text-center">{employeeAnalytics?.remainingLeaves}</h4>
                              <p className="text-center">Remaining Leaves</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="col-12 col-md-6 col-lg-3">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex align-items-center justify-content-between">
                      <div className="dashtitles">
                        <h4 className="">{inProgressProjects}</h4>
                        <p>Working</p>
                      </div>
                      <div className="icons_dash">
                        <GoProjectRoadmap
                          onClick={() => {
                            navigate("/projectassigntable");
                          }}
                          style={{ cursor: "pointer" }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
              {/* <div className="col-12 col-md-6 col-lg-3">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex align-items-center justify-content-between">
                      <div className="dashtitles">
                        <h4 className="">{failedProjects}</h4>
                        <p>Failure</p>
                      </div>
                      <div className="icons_dash">
                        <GoProjectRoadmap
                          onClick={() => {
                            navigate("/projectassigntable");
                          }}
                          style={{ cursor: "pointer" }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
              <div className="col-12"></div>
            </div>
          </div>
        </div>

        {/* {employeeData.data?.fullName && (
            <marquee className="marquee">
              <p className="marquee_div">
                Wish You a Very Happy Birthday {employeeData.data.fullName}
              </p>
            </marquee>
          )} */}
        {employeeDob === today ? (
          <marquee className="marquee">
            <p className="marquee_div">
              Wish You a Very Happy Birthday {employeeData.data.fullName}
            </p>
          </marquee>
        ) : ""}


        <hr></hr>

        <div className="row py-3">
          <div className="col-sm-8 mb-3">
            <div className="info-wrapper">
              <h6 className="detail-header"><Divider className="my-0" orientation="left">
                Project Status
              </Divider> </h6>
              <div className="row mt-4 mb-5">
                <div className="col-lg-3 col-md-3 col-sm-6 p-0">
                  <Flex className="progress-container" gap="small" wrap>
                    <Progress
                      type="circle"
                      percent={employeeAnalytics?.projects?.completedProjects}
                      className="ml-4 my-0 progress-wrapper" onClick={() => filteredProjects("completed")}
                    />
                    <p className="ml-5 my-0">Completed</p>
                  </Flex>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-6 p-0">
                  <Flex className="progress-container" gap="small" wrap>
                    <Progress
                      type="circle"
                      percent={employeeAnalytics?.projects?.inProgressProjects}
                      onClick={() => filteredProjects("inProgress")} className="ml-4 my-0 progress-wrapper"
                    />
                    <p className="ml-5 my-0">In Progress </p>
                  </Flex>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-6 p-0">
                  <Flex className="progress-container" gap="small" wrap>
                    <Progress type="circle"
                      percent={employeeAnalytics?.projects?.onHoldProjects}
                      onClick={() => filteredProjects("onhold")}
                      className="ml-4 my-0 progress-wrapper"
                    />
                    <p className="ml-5 my-0">On Hold</p>
                  </Flex>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-6 p-0">
                  <Flex className="progress-container" gap="small" wrap>
                    <Progress
                      type="circle"
                      percent={employeeAnalytics?.projects?.notStartedProjects}
                      className="ml-4 my-0 progress-wrapper"
                      onClick={() => filteredProjects("notStarted")}
                    />
                    <p className="ml-5 my-0">Not Started</p>
                  </Flex>
                </div>
              </div>
            </div>



            {/* <div className="chart_div">
              <Chart
                chartType="AreaChart"
                width="100%"
                height="400px"
                data={chartData}
                options={chartsOptions}
                loader={<Spin />}
              />
            </div> */}
          </div>
          <div className="col-12 col-md-4">
            <div className="images_data ">
              <div className="postds_ones">
                <div className="activity-wrapper">
                  <div className="">
                    <h6 className="detail-header"><Divider className="my-0" orientation="left">
                      Activity
                    </Divider> </h6>

                    <div className="card-body ">
                      <div className="card_announcements ">
                        {loading ? (
                          <Spin className="text-center mx-auto" />
                        ) : announcementsData.length > 0 ? (
                          announcementsData.slice(0, 2).map((announcement, index) => (
                            <div key={index} className="border p-2 mb-1">
                              <img
                                src={API_URL + announcement.image}
                                className="anouments"
                                alt="Announcement"
                              />
                              <div className="mt-2">
                                <p>{announcement.description}</p>
                              </div>
                            </div>
                          ))


                        )

                          : (
                            <p className="text-center text-xs">No announcements for today.</p>
                          )}
                      </div>
                      {
                        announcementsData.length > 0 &&
                        <div className="d-flex cursor-pointer justify-content-end align-items-center mt-2">
                          <a className="activity-txt mr-1" onClick={event}>
                            See all Announcement
                          </a>
                        </div>
                      }

                    </div>
                  </div>
                </div>
                <div className="event-modal mt-4">
                  <div className="card mb-0">
                    <div className="card-header">
                      <div className="d-flex align-items-center w-100 justify-content-between">
                        <div className="d-flex align-items-center gap-2">
                          <div className="users_list">
                            <h4 className="">Events</h4>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card-body event-body">
                      <div className="card_announcements">
                        {loading ? (
                          <Spin className="text-center mx-auto" />
                        ) : upcomingevent?.data?.length > 0 &&
                          upcomingevent?.data.some(
                            (event) =>
                              moment(event.eventDate).format("YYYY-MM-DD") === moment().format("YYYY-MM-DD")
                          ) ? (
                          upcomingevent?.data.map((event, index) =>
                            moment(event.eventDate).format("YYYY-MM-DD") === moment().format("YYYY-MM-DD") ? (
                              <div key={index} className="">
                                <div className="mt-2 border p-2">
                                  <b>{event?.eventName}</b>
                                  <p>{event.description}</p>
                                </div>
                              </div>
                            ) : null
                          )
                        ) : (
                          <p className="text-center text-xs">No Event for today.</p>
                        )}
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default DashBoard;